/**
 * Utility functions for sharing functionality
 */

/**
 * Copy text to clipboard
 * @param {string} text - Text to copy
 * @returns {Promise} - Promise that resolves when text is copied
 */
export const copyToClipboard = text => {
  return navigator.clipboard.writeText(text);
};

/**
 * Check if the Web Share API is available
 * @returns {boolean} - True if Web Share API is available
 */
export const isWebShareAvailable = () => {
  return typeof navigator !== 'undefined' && !!navigator.share;
};

/**
 * Check if the device is mobile
 * @returns {boolean} - True if the device is mobile
 */
export const isMobileDevice = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

/**
 * Share content using the Web Share API
 * @param {Object} shareData - Data to share
 * @param {string} shareData.title - Title to share
 * @param {string} shareData.text - Text to share
 * @param {string} shareData.url - URL to share
 * @returns {Promise} - Promise that resolves when content is shared
 */
export const shareWithWebAPI = shareData => {
  if (isWebShareAvailable()) {
    return navigator.share(shareData);
  }
  return Promise.reject(new Error('Web Share API not available'));
};

/**
 * Get the full URL from the current location
 * @returns {string} - Full URL
 */
export const getFullURL = () => {
  return typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '';
};
